import {FAV_ADD, FAV_REMOVE, FAV_GET, FAV_ADD_GROUP, FAV_REMOVE_GROUP, FAV_GET_GROUP} from '../actions/favorites';
import Vue from 'vue';

const state = { status: '', groups : [], favorites : [] };

const getters = {
	groupExists : (state) => (grp) => (state.groups.indexOf(grp) > -1),
	isFavorite : (state) => function (data) {
		let gid = state.groups.indexOf( data.group );
		if( gid !== -1 ) {
			return state.favorites[gid].indexOf( data.uid ) > -1;
		}
		return false;
	}
};

const actions = {

	[FAV_ADD] : ({commit, dispatch}, favData ) => {
		// console.log( 'action: ' + FAV_ADD, favData );
		commit( FAV_ADD, favData );
	},

	[FAV_REMOVE] : ({commit, dispatch}, favData ) => {
		commit( FAV_REMOVE, favData );
	}

};

const mutations = {
	[FAV_ADD_GROUP] : (state, group ) => {
		state.groups.push( group.name );
		// console.log( state.group, group );
	},
	[FAV_ADD] : (state, favData ) => {
		let gid = state.groups.indexOf( favData.group );

		if( gid === -1 ) {
			gid = state.groups.push( favData.group );
			gid--;
			state.favorites[ gid ] = [];
		}

		state.favorites[ gid ].push( favData.uid );

	},
	[FAV_REMOVE] : (state, favData) => {
		let gid = state.groups.indexOf( favData.group ),
			uid = state.favorites[ gid ].indexOf( favData.uid );

		if( uid > -1 ) {
			delete state.favorites[ gid ][ uid ];
			state.favorites = state.favorites.filter( (item) => ( item != null || typeof item != undefined ) );
		}
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};


// WEBPACK FOOTER //
// ./src/utils/store/modules/favorites.js